import { createSignal } from "solid-js";
import type { UserClaims } from "./types";

const KEY = "booking-control:jwt";

function decodeJwtPayload(token: string): UserClaims | null {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;
    const b64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = b64 + "=".repeat((4 - (b64.length % 4)) % 4);
    const json = atob(padded);
    const payload = JSON.parse(json);
    if (typeof payload.sub !== "string" || typeof payload.role !== "string") return null;
    return payload as UserClaims;
  } catch {
    return null;
  }
}

const initialToken = typeof localStorage !== "undefined" ? localStorage.getItem(KEY) : null;
const [token, setTokenInner] = createSignal<string | null>(initialToken);
const [claims, setClaims] = createSignal<UserClaims | null>(initialToken ? decodeJwtPayload(initialToken) : null);

export function getToken() {
  return token();
}

export function getClaims() {
  return claims();
}

export function setToken(t: string | null) {
  if (t) {
    localStorage.setItem(KEY, t);
    setTokenInner(t);
    setClaims(decodeJwtPayload(t));
  } else {
    localStorage.removeItem(KEY);
    setTokenInner(null);
    setClaims(null);
  }
}

export function isAuthenticated() {
  const c = claims();
  if (!c) return false;
  const nowS = Math.floor(Date.now() / 1000);
  return c.exp > nowS;
}

export function isAdmin() {
  return claims()?.role === "admin";
}
